<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AYyTUd/media/FC-9781035847716.jpg?1718046539638" alt="This image is the cover for the book Little Soul"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little Soul
      </h1>
      <p class="bookDescription body article font2">
        <p>Have you ever wondered about the deeper mysteries of life – how you arrived on this Earth, why you are here, and what happens when you pass on? If so, you may find a kindred spirit in Little Soul. Even amidst the tragedy and turmoil we see daily in the news, do you still catch glimpses of humanity’s positive potential? Perhaps, like Little Soul, you feel called to create real change in the world. Are you seeking a community of like-minded people – those not resigned to fear, but committed to taking meaningful action to help life flourish on this planet? If this sparks something inside you, then just maybe, YOU are Little Soul.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Hunter
      </h2>
      
      <p class="authorDescription body article">Jennifer Hunter is a retired mediator who lives in south-eastern Australia. She enjoys working in the garden and growing her own vegetables, baking chocolate desserts, singing pineal tones, and reading. This publication is her first attempt at a little novel and is loosely based upon her spiritual beliefs and experiences.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11d41c0f